import React from "react";
import { Typography, Box, Link, Tooltip } from "@mui/material";
import { format } from "date-fns";
import IndicatorDataGrid from "./IndicatorDataGrid";
import { BoxWrapper } from "../BoxWrapper";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

interface FSCData {
  fsc_document_link?: string;
  nra_approval_date?: string;
  categories?: any[];
  fsc_total_risk?: number;
  indicators?: any[];
  high_risk_levels?: string[];
}

interface FSCNationalRiskAssessmentProps {
  fscData: FSCData;
}

export default function FSCNationalRiskAssessment({ fscData }: FSCNationalRiskAssessmentProps) {
  return (
    <BoxWrapper style={{}}>
      <Tooltip
        title={
          <React.Fragment>
            Comprehensive assessment of social and environmental risks
            associated with sourcing non-certified wood from specific
            countries. Updated every five years. Sources: FSC
            International Document Center and FSC Risk Assessment
            Platform. For more information, see the{" "}
            <Link
              href="/understand-risk"
              target="_blank"
              style={{ color: "#6db2b8" }}
            >
              Understanding Risk section
            </Link>
            .
          </React.Fragment>
        }
        placement="top"
      >
        <Typography textAlign="center" variant="h4">
          FSC National Risk Assessment{" "}
          <InfoOutlinedIcon fontSize={"small"}></InfoOutlinedIcon>{" "}
        </Typography>
      </Tooltip>
      <Box
        sx={{ marginBottom: "15px" }}
        display="flex"
        flexDirection="row"
        justifyContent="space-around"
      >
        <Typography variant="subtitle1">
          {" "}
          Document Reference:{" "}
          <b>
            {" "}
            {fscData.fsc_document_link ? (
              <Link
                target="_blank"
                sx={{ cursor: "pointer" }}
                href={fscData.fsc_document_link}
              >
                {fscData.fsc_document_link}
              </Link>
            ) : (
              "No Document Available"
            )}
          </b>
        </Typography>
        <Typography variant="subtitle1">
          {" "}
          NRA Approval Date:{" "}
          <b>
            {fscData.nra_approval_date
              ? format(new Date(fscData.nra_approval_date), "PPP")
              : "No Data"}{" "}
          </b>
        </Typography>
      </Box>

      <Box>
        <Tooltip
          title={
            <React.Fragment>
              The number of 32 discreet indicators evaluated by FSC National Risk
              Assessments that is determined to have elevated risk associated with
              a specific attribute. Mitigation measures are identified for mitigating
              Specified Risk. Sources: FSC International Document Center and FSC
              Risk Assessment Platform. For more information, see the{" "}
              <Link
                href="/understand-risk"
                target="_blank"
                style={{ color: "#6db2b8" }}
              >
                Understanding Risk section
              </Link>
              .{" "}
            </React.Fragment>
          }
          placement="top"
        >
          <Typography variant="h6" sx={{ textAlign: "center" }}>
            Total Specified Risk Indicators
            <InfoOutlinedIcon fontSize={"small"}></InfoOutlinedIcon>: {fscData.fsc_total_risk}
          </Typography>
        </Tooltip>
      </Box>

      {fscData.categories?.map((category: any, index: number) => (
        <IndicatorDataGrid
          key={index}
          category={category}
          indicators={fscData.indicators}
          highRiskLevels={fscData.high_risk_levels || []}
        />
      ))}
    </BoxWrapper>
  );
}
